import { Injectable } from '@angular/core';
import { UserSessionService } from './user-session.service';

@Injectable()
export class UserStorageService {

  constructor(private userSession: UserSessionService) { 
    
  }

  getUser()
  {
    var user = JSON.parse(localStorage.getItem("user"));
    return user.original[0];
  }

  setUser(user){
    localStorage.setItem("user", JSON.stringify(user));
  }

  removeUser(){
    localStorage.removeItem("lastTime");
    localStorage.removeItem("active");
    localStorage.removeItem("user");
  }

  setInactive(){
    localStorage.setItem("active", 'false');
  }

  setActive(){
    localStorage.setItem("active", 'true');
  }

  isActive(){
    let act = localStorage.getItem('active');
    let user = localStorage.getItem("user");
    
    
    return (act == 'true' && user != null );
  }

  updateTime(){
    let dataAtual: Date = new Date();
    localStorage.setItem("lastTime", String(dataAtual.getTime()));
  }

  isBlock(){
    let dataAtual: Date = new Date();
    let lastTime: number = Number(localStorage.getItem("lastTime"));
    let tempoSessao: number = (Number(dataAtual.getTime()) - lastTime);
    let tokenLaravel = this.userSession.get();
    return (lastTime != null && lastTime != 0 && tempoSessao > 900000) || tokenLaravel== null;
  }



}



// WEBPACK FOOTER //
// ./src/app/services/user-storage.service.ts